import { Box, Typography } from "@mui/material";
import { useState } from "react";
import DataListingComponent from "../../Component/DataListingComponent";
import delImg from "../../Assets/delete.png";
import { API_GET, API_POST } from "../../API/config";
import { API_endspoints } from "../../API/API_endspoints";
import { useEffect } from "react";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import { toast } from "react-toastify";

const PAGE_SIZE_OPTIONS = [15];
const ReviewScreen = () => {
    const [data, setData] = useState();
    const [IsLoading, setIsLoading] = useState(true);
    const [totalData, setTotalData] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE_OPTIONS[0]);

    const handleReviewDelete = async (id) => {
        try
        {
            const f = new FormData();
            f.append("id", id);
            f.append("status", 0);

            const res = await API_POST(API_endspoints.DeleteReview, f);
            if (res?.s)
            {
                toast.success(res?.m);
                FetchReviewData();
            }
        } catch (error)
        {
            console.log(error);
        }
    };

    const column = [
        {
            headerClassName: "super-app-theme--header",
            field: "rowId",
            headerName: "#",
            width: 50,
            headerAlign: "center",
            renderCell: (cell) => {
                return page * PAGE_SIZE_OPTIONS + cell?.row?.rowId;
            },
        },

        {
            headerClassName: "super-app-theme--header",
            field: "",
            headerName: "Profile",
            width: 200,
            headerAlign: "center",
            renderCell: (cell) => (
                <Box
                    sx={{
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "1rem",
                        width: "100%",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 3,
                        }}
                    >
                        <img
                            className="ImgHover"
                            src={
                                API_endspoints.baseURL + cell?.row?.user_details?.profile_img
                            }
                            alt="icon"
                            height={40}
                            width={40}
                            style={{ borderRadius: "8px" }}
                        />
                    </Box>
                </Box>
            ),
        },
        {
            headerClassName: "super-app-theme--header",
            field: "user_details",
            headerName: "Name",
            flex: 1,
            minWidth: 150,
            headerAlign: "center",
            renderCell: (cell) => {
                return cell?.row?.user_details?.full_name;
            },
        },
        {
            headerClassName: "super-app-theme--header",
            field: "company_name",
            headerName: "Company Name",
            flex: 1,
            minWidth: 250,
            headerAlign: "center",

        },

        {
            headerClassName: "super-app-theme--header",
            field: "rating",
            headerName: "Rating",
            width: 70,
            headerAlign: "center",
            renderCell: (cell) => {
                return (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                        }}
                    >
                        {cell?.row?.rating}
                        <StarRoundedIcon style={{ color: "#ffa534", fontSize: "20px" }} />
                    </Box>
                );
            },
        },
        {
            headerClassName: "super-app-theme--header",
            field: "review",
            headerName: "Review",
            flex: 1,
            minWidth: 200,
            headerAlign: "center",
        },
        {
            headerClassName: "super-app-theme--header",
            field: "action",
            headerName: "Action",
            width: 150,
            headerAlign: "center",
            renderCell: (cell) => (
                <Box
                    sx={{
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "1rem",
                        width: "100%",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 3,
                        }}
                    >
                        <img
                            onClick={() => handleReviewDelete(cell?.row?.id)}
                            className="ImgHover"
                            src={delImg}
                            alt="icon"
                            height={24}
                            width={24}
                        />
                    </Box>
                </Box>
            ),
        },
    ];

    const handlePageChange = (e, newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (e) => {
        setRowsPerPage(parseInt(e.target.value, 10));
        setPage(0);
    };

    const FetchReviewData = async (page = 0, pageSize = PAGE_SIZE_OPTIONS[0]) => {
        try
        {
            setIsLoading(true);
            let count = page * pageSize;
            const res = await API_GET(
                `${API_endspoints.GetRatingAndReview}?count=${count}&offset=${pageSize}`
            );
            if (res && res?.s)
            {
                const RowData = res?.r?.map((x, i) => {
                    return {
                        rowId: i + 1,
                        ...x,
                    };
                });
                setData(RowData);
                setTotalData(res?.c ?? 0);
            } else
            {
                setData([]);
                setTotalData(0);
            }
            setIsLoading(false);
        } catch (error)
        {
            setIsLoading(false);
            console.log(error);
        }
    };

    useEffect(() => {
        FetchReviewData(page, rowsPerPage);
    }, [page, rowsPerPage]);

    return (
        <Box sx={{ height: "calc(100vh - 32px)" }}>
            <Box
                sx={{
                    height: "110px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    px: 2,
                    width: "100%",
                    background: "#ffffff",
                    borderBottom: "1px solid #CED7E4",
                }}
            >
                {/* <Box> */}
                <Typography
                    sx={{
                        fontSize: "26px",
                        fontWeight: 500,
                    }}
                >
                    Review Management
                </Typography>
            </Box>
            <Box
                sx={{
                    background: "#F4F4F4",
                    height: "calc(100% - 130px)",
                    width: "100%",
                    p: 2,
                }}
            >
                <DataListingComponent
                    data={data ?? []}
                    PAGE_SIZE_OPTIONS={PAGE_SIZE_OPTIONS}
                    loading={IsLoading}
                    totalData={totalData}
                    page={page}
                    Footer={true}
                    columns={column}
                    rowsPerPage={rowsPerPage}
                    handlePageChange={handlePageChange}
                    handleRowsPerPageChange={handleRowsPerPageChange}
                />
            </Box>
        </Box>
    );
};

export default ReviewScreen;
